import React, { useEffect } from "react";
import Header from "../Header/Header";
import Main from "../Main/Main";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import ContactPageTitle from "./ContactPageTitle";
import ContactSection from "./ContactSection";
import { useTranslation } from "react-i18next";

import "./Contact.css";
function Contact() {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("contact");
  }, [t]);

  return (
    <>
      <Header />
      <Main>
        <ContactPageTitle />
        <ContactSection />
      </Main>
      <Footer />
      <Link
        to="#"
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
      >
        <FontAwesomeIcon icon={faArrowUp} />
      </Link>
    </>
  );
}

export default Contact;
